import {
  DATA_CONNECTOR_GET_XANO_TABLE_BEGIN,
  DATA_CONNECTOR_GET_XANO_TABLE_SUCCESS,
  DATA_CONNECTOR_GET_XANO_TABLE_FAILURE,
  DATA_CONNECTOR_GET_XANO_TABLE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function getXanoTable(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_XANO_TABLE_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/tables`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_TABLE_SUCCESS,
            data: res.data.items,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_TABLE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}


export function dismissGetXanoTableError() {
  return {
    type: DATA_CONNECTOR_GET_XANO_TABLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_XANO_TABLE_BEGIN:

      return {
        ...state,
        getXanoTablePending: true,
        getXanoTableError: null,
      };

    case DATA_CONNECTOR_GET_XANO_TABLE_SUCCESS:

      return {
        ...state,
        getXanoTablePending: false,
        getXanoTableError: null,
        xanoDataSourceTables: action.data
      };

    case DATA_CONNECTOR_GET_XANO_TABLE_FAILURE:

      return {
        ...state,
        getXanoTablePending: false,
        getXanoTableError: action.data.error,
      };

    case DATA_CONNECTOR_GET_XANO_TABLE_DISMISS_ERROR:

      return {
        ...state,
        getXanoTableError: null,
      };

    default:
      return state;
  }
}
